import React from 'react';

const FormsPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/forms',
			exact: true,
			component: React.lazy(() => import('./FormsPage')),
		},
		{
			path: '/admin/internalform/:region/:formUrlId',
			exact: true,
			component: React.lazy(() => import('./InternalFormPage')),
		},
	],
};

export default FormsPageConfig;
